import { useNavigate } from 'react-router-dom';

import { Icon, Link, Text } from '@nvision/ui';

import { Card } from '@/components/card';
import { Page } from '@/components/page';

import styles from '../tender.module.css';

export const TenderNew: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Page>
      <Page.Main className={styles.main}>
        <Link className={styles.link} iconLeft={<Icon name="arrow-left" size={20} />} onClick={() => navigate(-1)}>
          Back to previous page
        </Link>
        <div className={styles.container}>
          <Card>
            <Card.Header title="Tender Information" />
          </Card>
          <Card.Main>
            <Text size="lg" weight="semibold">
              Tender Form
            </Text>
          </Card.Main>
        </div>
      </Page.Main>
    </Page>
  );
};
